import html2canvas from "html2canvas";
import ReactDOM from "react-dom/client"; 
import CryptoJS from "crypto-js"; 
import cryptography from "./encrypt"

// import AboutJSON from "./about.json";
import HomeJSON from "./home.json";
import FQAJSON from "./faq.json";
import PricingPlanJSON from "./pricingPlan.json";
import ContactFormJSON from "./contactForm.json"
import ResumeJSON from "./resume.json"

import footerJson from "./footer.json";
import headerJson from "./header.json";
import React from "react";
import { Modal, IconList, Blocks, Images, VideosModel, ImageCropperModal } from "./helpers";
import config from "../config";
import { svgIcon } from "./utility";
import htmlPreview from "./htmlPreview";


export const elementBackground2 = function(backgroundColor) {
    const style = {
      backgroundSize:"",
      backgroundImage:""
    }
    if(backgroundColor)  {
        if(backgroundColor !== "") {
            if(backgroundColor.indexOf("__CDN__PATH__") !== -1) {
                style.backgroundImage = `url('${app.cdn(backgroundColor)}')`;
                style.backgroundSize = "cover";
                if(backgroundColor.indexOf("/patterns/") !== -1) {
                  style.backgroundSize = "120px 120px";
                }
            }
            else if(backgroundColor.indexOf("https://") !== -1 || backgroundColor.indexOf("http://") !== -1) {
              style.backgroundImage = `url('${backgroundColor}')`;
              style.backgroundSize = "cover";
            }
            else if(backgroundColor.indexOf("linear-gradient(") !== -1) {
              style.backgroundImage = backgroundColor;
              style.backgroundSize = "cover";
            }
            else {
              style.backgroundColor = backgroundColor;
              style.backgroundImage = `inherit`;
            }
        }
    }
    return style;
}

export const elementWeight = function(weight) {  
    if (weight) {
         if(weight === "medium"){
            return "500"
         }else if(weight === "bold"){
            return "700"
         }else if(weight === "italic"){
            return "italic"
         }
         else if(weight === "boldItalic"){
            return "800"
         }else{
            return "400"
         }
    } 
}

const Modal2 = function(props){
  return <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">{props.title}</h5>
        <button type="button" className="btn-close modal-close close-popup" onClick={() => props.close()}></button>
      </div>
      <div className="modal-body">
        {props.children}
      </div>
    </div>
  </div>
}

export class UndoRedo extends React.Component {
constructor(props) {
    super(props);
    this.state = {
      undo: app.getUndoRedo("undo"),
      redo: app.getUndoRedo("redo")
    }
    this.update = this.update.bind(this);
}
componentWillReceiveProps() {
    this.setState({
      undo: app.getUndoRedo("undo"),
      redo: app.getUndoRedo("redo")
    })
}
componentDidUpdate() {
  // const blocks = document.querySelectorAll(".block-view");
  // if(blocks.length) { 
    
  //   blocks[0].classList.add("first-child");
  //   blocks[blocks.length - 1].classList.add("last-child");

  //   const footerBlocks = document.querySelectorAll(".block-view.footer");
  //   if(footerBlocks.length) {
  //     footerBlocks[0].classList.add("first-child");
  //     footerBlocks[0].previousSibling.classList.add("last-child");
  //   }
  // }
}
update(e) {
  if(e.currentTarget.classList.contains("disabled")) {
    return false;
  }
    let a = null;
    let type = "undo";
    
    if (e.currentTarget.classList.contains("undo")) {
      let undo = app.getUndoRedo("undo");
      a = undo.pop();
      //app.saveRedo(a);
      app.setUndoRedo("undo", undo);
    }
    else {
      type = "redo";

      let redo = app.getUndoRedo("redo");
      a = redo.pop();
      //app.saveUndo(a);
      app.setUndoRedo("redo", redo);
    }
    this.props.update(a, type);
}
updateBtn(type) {
  if(document.querySelectorAll(".undo-btn, .redo-btn")) {
    if(document.querySelectorAll(".undo-btn, .redo-btn").length) {
      document.querySelectorAll(".undo-btn, .redo-btn").forEach(function(v){
        v.classList.remove("disabled");
      });
      if(type === "undo") {
        document.querySelector(".undo-btn").classList.add("disabled");
      }
      if(type === "redo") {
        document.querySelector(".redo-btn").classList.add("disabled");
      }
      if(type === "both") {
        document.querySelector(".undo-btn").classList.add("disabled");
        document.querySelector(".redo-btn").classList.add("disabled");
      }
    } 
  }
}

render() {
    let { undo, redo } = this.state;
    let disabledUndo = "";
    let disabledRedo = "";
    
    if (undo.length === 0 && redo.length === 0) {
      disabledUndo = "disabled";
      disabledRedo = "disabled";
      this.updateBtn("both");
    }
    else {
      this.updateBtn();
      if (undo.length === 0) {
        disabledUndo = "disabled";
        this.updateBtn("undo");
      }
      if (redo.length === 0) {
        disabledRedo = "disabled";
        this.updateBtn("redo");
      }
    }
   
    
    return <div className="undo-redo-container">
      <a className={`undo ${disabledUndo}`} onClick={this.update}>
        {svgIcon.undo}
      </a>
      <a className={`redo ${disabledRedo}`} onClick={this.update}>
        {svgIcon.redo} 
      </a>
    </div>
}
}
 

const app = {
  loadConfig:async function(){
    if(localStorage.getItem("aiConfig")) {
      return JSON.parse(localStorage.getItem("aiConfig"));
    }
    let response = await fetch("https://api-fetch.mediadirhub.com/ai-builder", {
      method:"POST",
      body:JSON.stringify({
        "method":"getConfig",
        "lang":app.appLang()
      })
    });
    response = await response.json();
    localStorage.setItem("aiConfig", JSON.stringify(response));
    return response;
  },
  getConfig:function(){
    if(localStorage.getItem("aiConfig")) {
      return JSON.parse(localStorage.getItem("aiConfig"));
    }
    return config;
  },
  appLang:function(){
    //return "es";
    if(app.getProject() === "live") {
      return localStorage.getItem("lang")?localStorage.getItem("lang"):"en";
    }
    return "en";
  },
  saveImage:async function(path, data){
    let response = await fetch("https://api-fetch.mediadirhub.com/ai-builder", {
      method:"POST",
      body:JSON.stringify({
        method:"saveImage",
        path,
        data
      })
    });
    return response;
  },
  
    localPage:function(){
      //return {dynamicAIData:[headerJson.headerAIData[0], footerJson.footerAIData[0]]}
      return {
        dynamicAIData:[headerJson.headerAIData[0], ...HomeJSON.dynamicAIData, footerJson.footerAIData[0]]
      }
      return {
        dynamicAIData:[...ResumeJSON.dynamicAIData]
      }
      return {
        dynamicAIData:[...ContactFormJSON.dynamicAIData]
      }
      return {
        dynamicAIData:[...PricingPlanJSON.dynamicAIData]
      }
    },
    savePage:async function(page, data){  
      // if(page === '/' || page === 'home'){
      //   return HomeJSON;
      // }
      // else{
      //   let response = await fetch('https://api.mediadirhub.com/pages', {
      //     method: 'POST',
      //     body: JSON.stringify({
      //       page,
      //       data:JSON.stringify(data)
      //     })
      //   })
      //   return await response.json();
      // }
      let response = await fetch('https://api.mediadirhub.com/pages', {
        method: 'POST',
        body: JSON.stringify({
          page,
          data:JSON.stringify(data)
        })
      })
      return await response.json();
     // return AboutJSON;
    },
    userImages:function(data) {
      if(data) {
        localStorage.setItem("allImages", JSON.stringify(data));
      }
      else {
        let userImages = [];
        if (localStorage.getItem("allImages")) {
          userImages = JSON.parse(localStorage.getItem("allImages"));
        }
        return userImages;
      }
    },
    
    

    userVideos:function(data) { 
      if(data) {
        localStorage.setItem("userCustomVideos", JSON.stringify(data));
      }
      else {
        let userVideos = [];
        if (localStorage.getItem("userCustomVideos")) {
          userVideos = JSON.parse(localStorage.getItem("userCustomVideos"));
        }
        return userVideos;
      }
    },
  
    getUndoRedo:function(){
        return [] 
    },
    getDom:function() {
      return document.querySelector("#iframe").contentWindow.document;
    },
    getWin:function() {
      return document.querySelector("#iframe").contentWindow;
    },
    loadCSS:function(file) {
        const link = document.createElement("link");
        link.setAttribute("rel", "stylesheet");
        if(file.indexOf("https:") !== -1) {
          link.setAttribute("href", file);
        }
        else {
          link.setAttribute("href", `${window.aiHost}${file}?version=${window.aiVersion}`);
        }
        app.getDom().head.appendChild(link);
    },
    loadJS:function(file) {
      const link = document.createElement("script");
      // link.setAttribute("type", "text/js");
      if(file.indexOf("https:") !== -1) {
        link.setAttribute("src", file);
      }
      else {
        link.setAttribute("src", `${window.aiHost}${file}`);
      }
      app.getDom().head.appendChild(link);
    },
    iconPopup:function(callback) {
      alert("done3")
      app.getCreateRoot().render(<Modal title="Select Icon">
        <IconList callback={callback} />
      </Modal>);
    },
  imagePopup:function(src, callback, key) {
      app.getCreateRoot("images-wrapper").render(<Images src={src} type={key} callback={function(key, val){
        callback(key, val);
        if(document.querySelector("#images-wrapper .modal-close")){
          document.querySelector("#images-wrapper .modal-close").click();
        } 
      }} />);
  },
  validateImage:function(file, w, h){
    return new Promise(function(resolve, reject){
      let img = new Image()
      img.src = window.URL.createObjectURL(file)
      img.onload = () => {
          if(img.width === w && img.height === h){
            resolve(true);
            return false;
          }
          //resolve(true);
          reject(false)
      }
    });
  },
  cropingModel:function(e, id){
    return new Promise(function(resolve,reject){
      const fileInput = e.currentTarget.files;
      let width = e.currentTarget.getAttribute('width');
      let height = e.currentTarget.getAttribute('height');
      const type = e.currentTarget.getAttribute('data-type');
      let ratio = width/height;
      if(id === "logo") {
        width = 600;
        height = 200;
        ratio = null;
      }

      if (fileInput.length > 0) {
          const file = fileInput[0];
     
          app.getCreateRoot().render(
              <ImageCropperModal 
                  file={file} 
                  width={width} 
                  height={height} 
                  type={type} 
                  ratio={ratio}
                  saveHeaderImages={(croppedFile) => {
                      // ReactDOM.unmountComponentAtNode(div);
                      //div.remove();
                      resolve(croppedFile); // Pass the cropped image to the callback
                      app.preloader(true);
                  }} 
                  removeImage={() => {
                      // ReactDOM.unmountComponentAtNode(div);
                     // div.remove();
                  }} 
              />
              
          );      
      }else{
        reject(new Error("No file selected"))
      }

    })
  },
  uploadLogo:function(event, id, callback) {
    if(event.currentTarget.files.length) {
      app.cropingModel(event, id).then(function(croppedFile){
        if(id === "logo") {
          const formData = new FormData();
          formData.append("method", "saveWebsiteLogo");
          formData.append("appId", localStorage.getItem("aiAppId"));
          formData.append("file", croppedFile);
          formData.append("live", true);
          
          fetch(`${config.apiFetch}/upload-logo`, {
            method:"POST",
            body:formData
          }).then(function(response) {
            response.json().then(function(response) {
              callback("src", `${app.config().bucket}/media/user_space/${response.path}`);
              app.preloader(false);   
            });
          });
        }
        else {
          const formData = new FormData();
          formData.append("method", "saveCustomLogo");
          formData.append("appId", localStorage.getItem("aiAppId"));
          formData.append("customLogo", croppedFile);
          app.postForm(formData).then(function(response){
            if(response.data) {
              if(response.data.logo) {
                //localStorage.setItem("custom_app_icon_image", response.data.logo);
                localStorage.setItem("custom_app_icon_image", response.data.logo.split("/").pop());
                callback("src", response.data.logo);
                app.preloader(false);   
              }
            }
          });
        }
     
      }).catch(function(){
        alert("Please select valid file");
        app.preloader(false);   
      })
      // const file = event.currentTarget.files[0];
      // app.preloader(true);
      // app.validateImage(file, 1024, 1024).then(function(){
        
      // }).catch(function(){
      //   alert("The maximum image upload size recommended is 1024X1024");
      //   app.preloader(false);
      // });
    }
  },
  blockPopup:function(callback) {
      app.getCreateRoot("BlocksWrapper").render(<Blocks callback={callback} />);
  },
  ///iPhone|iPad|iPod|Android
  isMobile:function() {
    ///iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    var isMobile = /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent) || /Macintosh/.test(navigator.userAgent) && 'ontouchend' in document;
    if (isMobile) {
        document.body.classList.add("isMobileEnable")
        return "is-mobile";
    }
    else {
        return "";
    }
},
  config:function() {
    return config;
  },
  cdn:function(text) {
    if(text) {
      return text.replaceAll("__CDN__PATH__", `${app.config().bucket}/`);
    }
    return text;
  },
  fonts:function(){
    return new Promise(function(resolve, reject){
        // if(localStorage.getItem("fonts")) {
        //     resolve(JSON.parse(localStorage.getItem("fonts")))
        // }
        // else {
            window.fetch('https://www.googleapis.com/webfonts/v1/webfonts?sort=popularity&key=AIzaSyBEMxevrXHc6tk7-B7qYpMwfqBEEDzWA5M')
            .then((response) => response.json())
            .then(function(data){
              let fn = data.items.filter(function(v){
                  return v.family !== "Material Icons";
              }).map(function(v){
                  return v.family;
              }); 
              localStorage.setItem("fonts", JSON.stringify(fn))
              resolve(JSON.parse(localStorage.getItem("fonts")))
            });
       //}
    })
    },
   
    htmlPaste:function(e){
      const html = e.clipboardData.getData('text/html');
      if(html) {
          const htmlDiv  =  document.createElement("div");
          htmlDiv.innerHTML = html;
          htmlDiv.querySelectorAll("*").forEach(function(v){
              v.removeAttribute("style");
              v.removeAttribute("class");
              v.removeAttribute("contenteditable");
              
          })
          htmlDiv.querySelectorAll("img, iframe, video, script").forEach(function(v){
              v.remove();
          })
          if(e.currentTarget.classList.contains("editor-area")) {
              document.execCommand("insertHTML", false, e.clipboardData.getData('text/plain'));
          }
          else {
              app.getDom().execCommand("insertHTML", false, e.clipboardData.getData('text/plain'));
          }
      }
      else {
          if(e.currentTarget.classList.contains("editor-area")) {
              document.execCommand("insertHTML", false, e.clipboardData.getData('text/plain'));
          }
          else {
              app.getDom().execCommand("insertHTML", false, e.clipboardData.getData('text/plain'));
          }
      }
      e.preventDefault();
    },
    scroll:function(callback) {
      app.getWin().addEventListener('scroll', function(event) {
          callback(app.getWin().scrollY + 0);
      }, false);
  },
  scrollTop:function(y) {
    app.getDom().body.scrollTop +=   y;
  },
  getDevice:function() {
     if(localStorage.getItem("device") === "mobile") {
       return false;
     }
     return  true;
  }, 
  getProject:function() {
    return "live";
  },
  fetchPost:async function(data, mode) { 
    if(!mode) {
      app.preloader(true);
    }
    data["project"] = "pages";
    let response = await fetch(app.config().postURL, {
      // body:JSON.stringify({
      //     payload:cryptography.encrypt2(JSON.stringify(data))
      // }),
      body:JSON.stringify(data),
      method: "POST",
      // headers:{
      //   'Content-Type': 'application/json'
      // }
    });
    response = await response.json();
    //response = JSON.parse(cryptography.decrypt2(response.data));
    
    console.log(data, response);

    if(!mode) {
      app.preloader(false);
    }
    return response;
 },
 fetchUsers:async function(data, mode) { 
    if(!mode) {
      app.preloader(true);
    }
    data["project"] = "users";
    let response = await fetch(app.config().postURL, {
      body:JSON.stringify(data),
      method: "POST"
    });
    
    response = await response.json();
    
    console.log("fetchUsers", data, response);

    if(!mode) {
      app.preloader(false);
    }
    return response;
 },
 fetchModules:async function(data, mode) { 
    if(!mode) {
      app.preloader(true);
    }
    data["project"] = "modules";
    let response = await fetch(app.config().postURL, {
      body:JSON.stringify(data),
      method: "POST"
    });
    
    response = await response.json();

    if(!mode) {
      app.preloader(false);
    }
    return response;
 },
 fetchLivePost:async function(data, mode) { 
  if(!mode) {
    app.preloader(true);
  }
  let url = "https://snappy.appypie.com/webservices/aiEditorService.php";
  let response = await fetch(url, {
    method:"POST",
    body:JSON.stringify(data)
  })
  response = await response.json();
  if(!mode) {
  app.preloader(false);
  }
  return response;
},
  postForm:async function(data, mode) {
    if(!mode) {
      app.preloader(true);
    }
    data.append("encrypt", true);
    let response = await fetch(app.config().postURL, {
      method:"POST",
      body:data
    })
    response = await response.json();
    //response = JSON.parse(cryptography.decrypt2(response.data));
    if(!mode) {
      app.preloader(false);
    }
    return response;
  },
  loadImage:function(text, callback) {
    app.preloader(true);
    fetch("https://api-fetch.mediadirhub.com/vectorize", {
      method:"POST",
      body:JSON.stringify({
        method:"getTextImage",
        text:text
      })
    }).then(function(response){
      response.json().then(function(response){
        callback(response);
        app.preloader(false);
      })
    })
  },
  setFonts:function(response) {
      let setFonts = [];
      response.dynamicAIData.forEach(function(v){
        for(var k in v.elements) {
            if(v.elements[k]["properties"]["fontFamily"]) {
                if(v.elements[k]["properties"]["fontFamily"] !== "") {
                    setFonts.push(v.elements[k]["properties"]["fontFamily"]);
                }
            }
            if(v.elements[k].viewType === "grid") {
                v.elements[k].items.forEach(function(val){
                    
                    for(var key in val) {
                        //console.log(key, val[key])
                        if(key !== "viewType" && key !== "properties" && key !== "gridId" && key !== "viewId") {
                            if(val[key]["properties"]["fontFamily"]) {
                                if(val[key]["properties"]["fontFamily"] !== "") {
                                    setFonts.push(val[key]["properties"]["fontFamily"]);
                                }
                            }
                        } 
                    }
                })
            }
        }
      })
    setFonts = [...new Set(setFonts)]
    setFonts = setFonts.map(function(v){
       return v.replace(/ /g,"+");
     }).join(":wght@400;600;700&family=");
     //console.log(setFonts);
    let fontLink = app.getDom().querySelector("#googleFonts");
    if(!fontLink) {
      
      fontLink = document.createElement("link");
      fontLink.setAttribute("rel", "stylesheet");
      fontLink.setAttribute("id", "googleFonts");
      //link.setAttribute("href", file);
      app.getDom().head.appendChild(fontLink);
      
    }

    fontLink.setAttribute("href", `https://fonts.googleapis.com/css2?family=${setFonts}:wght@400;600;700&display=swap`)
        
  },
  setFontsLive:function(response) {
    let setFonts = [];
    response.dynamicAIData.forEach(function(v){
      for(var k in v.elements) {
          if(v.elements[k]["properties"]["fontFamily"]) {
              if(v.elements[k]["properties"]["fontFamily"] !== "") {
                  setFonts.push(v.elements[k]["properties"]["fontFamily"]);
              }
          }
          if(v.elements[k].viewType === "grid") {
              v.elements[k].items.forEach(function(val){
                  
                  for(var key in val) {
                      //console.log(key, val[key])
                      if(key !== "viewType" && key !== "properties" && key !== "gridId" && key !== "viewId") {
                          if(val[key]["properties"]["fontFamily"]) {
                              if(val[key]["properties"]["fontFamily"] !== "") {
                                  setFonts.push(val[key]["properties"]["fontFamily"]);
                              }
                          }
                      } 
                  }
              })
          }
      }
    })
  setFonts = [...new Set(setFonts)]
  setFonts = setFonts.map(function(v){
     return v.replace(/ /g,"+");
   }).join(":wght@400;600;700&family=");
   //console.log(setFonts);
  let fontLink = document.querySelector("#googleFonts");
  if(!fontLink) {
    
    fontLink = document.createElement("link");
    fontLink.setAttribute("rel", "stylesheet");
    fontLink.setAttribute("id", "googleFonts");
    //link.setAttribute("href", file);
    document.head.appendChild(fontLink);
    
  }

  fontLink.setAttribute("href", `https://fonts.googleapis.com/css2?family=${setFonts}:wght@400;600;700&display=swap`)
      
  },
  preloader:function(mode) {
    if(document.querySelector(".app-loader")) {
      if(mode) {
        document.querySelector(".app-loader").style.display = "block";
      }
      else {
        document.querySelector(".app-loader").style.display = "none";
      }
    }
 },
  isOnline() {
    if (navigator.onLine) {
      return true;
    } else {
      return false;
    }
  },
  fetchBuilder:async function(data, mode){
    if(!mode) {
      app.preloader(true);
    }
    try {
      let response = await fetch(config.postURL, {
          method:"POST",
          body:JSON.stringify(data)
      });
      response = await response.json();
      if(!mode) {
        app.preloader(false);
      }
      return response;
    } catch (error) {
      if(!mode) {
        app.preloader(false);
      }
    }
  },
  getColor:function(argb){
    if(argb) {
      if(argb.length === 7) {
        return argb;
      }
      else {
        return argb.replace(argb.substr(1, 2), "") + argb.substr(1, 2);
      }
      // console.log("argb", argb, argb.length)
      // // console.log("alpha", argb.substr(1, 2))
      // // console.log("red", argb.substr(3, 2))
      // // console.log("green", argb.substr(5, 2))
      // // console.log("blue", argb.substr(7, 2))
      // let red, green, blue, alpha, alphaFraction = "";
      // if(argb.length === 7){
        
      //   red = parseInt(argb.substr(1, 2), 16);
      //   green = parseInt(argb.substr(3, 2), 16);
      //   blue = parseInt(argb.substr(5, 2), 16);

      //   console.log('inside 7',argb, red, green, blue)  
      // }else if(argb.length > 7){
      //   alpha = parseInt(argb.substr(1, 2), 16);
      //   red = parseInt(argb.substr(3, 2), 16);
      //   green = parseInt(argb.substr(5, 2), 16);
      //   blue = parseInt(argb.substr(7, 2), 16); 
      //   alphaFraction = (alpha / 255).toFixed(2); 
      // } 
      // return `rgba(${red}, ${green}, ${blue}, ${alphaFraction})`;
    }
    return "";
  },
  getPlanColor:function(argb){
    if(argb) {
      if(argb.length === 7) {
        return argb;
      }
      else {
        return argb.replace(argb.substr(1, 2), "");
      } 
    }
    return "";
  },
  combineColor(color, opacity) {
    console.log("color, opacity", color, opacity); 
    opacity = Math.max(0, Math.min(100, opacity));
    
    // Convert opacity to a 2-digit hex value
    let newAlpha = Math.round((opacity / 100) * 255).toString(16).padStart(2, '0').toUpperCase();
    
    // Check if the color has 8 characters (including the '#')
    if (color.startsWith('#') && color.length === 9) {
      let existingAlpha = color.substring(1, 3);
      let rgb = color.substring(3); 
      return `#${newAlpha}${rgb}`;
    }
    
    // Check if the color has 7 characters (including the '#')
    if (color.startsWith('#') && color.length === 7) {
      let rgb = color.substring(1);
      return `#${newAlpha}${rgb}`;
    } 
    console.error("Invalid color format: Must be in the format #RRGGBB or #AARRGGBB");
    return color; // Return the original color if invalid
  },   
  getOpacity(color) {
    if (color) {
      if (typeof color === 'string' && color.startsWith('#') && color.length === 9) {
        const alphaHex = color.substring(1, 3); // Extract AA
        const alphaDecimal = parseInt(alphaHex, 16) / 255; // Convert to decimal and normalize
        const opacityPercentage = alphaDecimal * 100; // Convert to percentage
        return Math.floor(opacityPercentage); // Return the integer part only
      }
      return 100; // Default opacity if the color format is not as expected
    }
  },
  rgbaToHex(rgba) { 
    console.log("rgba", rgba)
    if (rgba && rgba.startsWith("#")) { 
      if (rgba.length === 7) {
          return rgba;
      } else {
        return rgba.replace(rgba.substr(1, 2), "") + rgba.substr(1, 2);
      } 
    }
    
    const parts = rgba.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+),\s*(\d*\.?\d+)?\)$/);
    console.log("coming-rgbaToHex-parts", parts);

    if (!parts) {
      return null;
    }

    // Convert each component to hexadecimal
    let r = parseInt(parts[1]).toString(16).padStart(2, '0');
    let g = parseInt(parts[2]).toString(16).padStart(2, '0');
    let b = parseInt(parts[3]).toString(16).padStart(2, '0');

    // Handle alpha (opacity)
    let a = parts[4] ? Math.round(parseFloat(parts[4]) * 255).toString(16).padStart(2, '0') : '';

    // console.log("rgbaToHex", a, r, g, b); 
    return `#${a}${r}${g}${b}`;
  },
  isValidColor(value) {
    // Check if the value is a valid hex color
    return /^#[0-9A-Fa-f]{6}$/.test(value);
  },
  debounce(func, wait) {
    let timeout;
    return function(...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  },
  loadScript:function(src, id) {
    return new Promise((resolve, reject) => {
      if(document.querySelector("#" + id)) {
        resolve();
      }
      else {
        const tag = document.createElement("script");
        tag.async = true;
        tag.src = src;
        tag.id = id;
    
        tag.addEventListener("load", () => {
          resolve();
        });
    
        tag.addEventListener("error", () => {
          reject();
        });
        document.head.appendChild(tag);
      }
    })
    
  },
  getItemValue(data, key) {
    if(data.viewType === "view") {
      let value = undefined;
      if(data["properties"][key]) {
        value = data["properties"][key];
      }
      // for(var k in data.elements) {
      //   if(data.elements[k]["properties"][key]) {
      //     value = data.elements[k]["properties"][key];
      //   }
      // }
      return value;
    }
    else if(data.viewType === "gridItem") {
      let value = undefined;
      if(data["properties"][key]) {
        value = data["properties"][key];
      }
      // console.log(data);
      // for(var k in data) {
      //   if(["gridItem", "properties", "gridId", "viewId", "viewType"].indexOf(k) === -1) {
      //     value =  data[k]["properties"][key];
      //   }
      // }
      return value;
    }
  },
  getAllMaster:async function() {
    return await app.fetchLivePost({"method":"getAllMaster"});
  },
  getMaster(id, callback) {
    app.getAllMaster().then(function(response){
      let block = null;
      if(response.data) {
        response.data.forEach(function(v){
          if(v.title === id) {
            block = v;
          }
        })
      }
      callback(block);
    });
  },
  getPage(id, callback) {
    app.fetchPost({
      "method":"getAllPages",
      "lang":"en"
    }).then(function(response){
      let itemData = null;
      if(response.data) {
          response.data.forEach(function(v){
              if(v.id === id) {
                  itemData = v;
              }
          });
      }
      callback(itemData);
    })
  },
  
  toast:function(txt) {
    const div = document.createElement("div");
    div.setAttribute("class", "toast show align-items-center text-white bg-success border-0 position-fixed end-0 bottom-0 m-2");
    div.style.zIndex = "99999";
    div.innerHTML = `
    <div class="d-flex">
    <div class="toast-body">
      ${txt}
    </div>
  </div>
    `
    document.body.appendChild(div);
    setTimeout(function(){
      div.remove();
    }, 3000)
  },
  getLang:function(key) {
    let langSettings = app.getConfig().languageSettings;
    if(langSettings[key]) {
      return langSettings[key];
    }
    return key;
  },
  saveUndo:function(next){
    let data  = [];
    if(localStorage.getItem("undo")) {
        data = JSON.parse(localStorage.getItem("undo"));
    }
    if(data.length === 10) {
        data.shift();
    }
    data.push(next);
    localStorage.setItem("undo", JSON.stringify(data));
    // if(data.length) {
    //   if(next !== data[data.length - 1]) {
    //     data.push(next);
    //     localStorage.setItem("redo", JSON.stringify([]));
    //     localStorage.setItem("undo", JSON.stringify(data));
    //   }
    // }
    // else {
    //     data.push(next);
    //     localStorage.setItem("redo", JSON.stringify([]));
    //     localStorage.setItem("undo", JSON.stringify(data));
    // }
  },
  saveRedo:function(next){
    let data  = [];
    if(localStorage.getItem("redo")) {
        data = JSON.parse(localStorage.getItem("redo"));
    }
    data.push(next);
    localStorage.setItem("redo", JSON.stringify(data));
 },
  getUndoRedo:function(type){
    let data  = [];
    if(localStorage.getItem(type)) {
        data = JSON.parse(localStorage.getItem(type));
    }
    return data;
  },
  setUndoRedo:function(type, data){
      localStorage.setItem(type, JSON.stringify(data));
  },
  resizeBlockView:function(type, data){
    setTimeout(function(){
      app.getDom().querySelectorAll(".block").forEach(function(v, i){
        if(document.querySelectorAll(`.block-view`)[i]) { 
          document.querySelectorAll(`.block-view`)[i].style.height = v.offsetHeight + "px";
        }
        if(v.offsetHeight < 150){
          if(i !== 0){
            if((app.getDom().querySelectorAll(".block").length - 1) === i) {
              if(document.querySelectorAll(`.block-view`)[i]){
                document.querySelectorAll(`.block-view`)[i].classList.add("small-last-child")
              }  
            }
          }
          
        } 
      })
    },500);
  },
  setPageBodyHeight:function(type, data){
    setTimeout(function(){
        let iframe = app.getDom();
        // get header height
        let getHeader = iframe.querySelector('[widget-type="headerAi"]');
        let getHeaderHeight = getHeader ? getHeader.offsetHeight : 0; 
        // let getHeaderHeight = getHeader.offsetHeight;

        // get footer height
        let getFooter = iframe.querySelector('[widget-type="footerAi"]');
        let getFooterHeight = getFooter ? getFooter.offsetHeight : 0;
        // let getFooterHeight = getFooter.offsetHeight;

        let editorPageBody = iframe.querySelector(".page_body")
       
        let headerFooterHeight = getHeaderHeight + getFooterHeight ;

        if(getHeader && getFooter){
          // setelementStyle
          editorPageBody.style.minHeight =  `calc(100vh - ${headerFooterHeight}px)`;
        }
    },500)
  },
  isParents(event, match) {
    const parents = [];
    const element = event.target;
    let mode = false;
    if (element.matches(`.${match}`)) {
      // console.log("Ravi ");
      mode = true;
    }
    let currentElement = element.parentNode;

    while (currentElement) {
      parents.push(currentElement);
      currentElement = currentElement.parentNode;
    }
    parents.pop();
    parents.pop();
    parents.forEach(function(v){
      // console.log(v);
      if(v.classList.contains(match)) {
        mode = true;
      }
    })
    // console.log(element, parents);
      return mode;
    },
    encrypt:function(data) {
      const secretInfo = app.getSecret();
      const key = CryptoJS.enc.Utf8.parse(secretInfo.apiSecret);
      const iv = CryptoJS.enc.Utf8.parse(secretInfo.apiIv);
      let cipher = CryptoJS.AES.encrypt(data, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
      });
      return cipher.toString();
    },
    decrypt:function(data) {
      const secretInfo = app.getSecret();
      const key = CryptoJS.enc.Utf8.parse(secretInfo.apiSecret);
      const iv = CryptoJS.enc.Utf8.parse(secretInfo.apiIv);
      let cipher = CryptoJS.AES.decrypt(data, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
      });
      return cipher.toString(CryptoJS.enc.Utf8);
    },
  
    getSecret:function() {
      const data = CryptoJS.AES.decrypt(`U2FsdGVkX19GhMg6SagmB8zDvIAAIY8M/OjMwqY1z8a9KQaQHjuKx/Tq6gauzKkX943V/T9cgKMPw8CSsSbtx4zZwvAyI8KFmLqRrjsVXjntFtC1o2f3ev9afNx/k8oVQPi1p5pbVMCm3WpC1BQv3/9CChQXGwSI1pWQfJ9fYqQ=`, '8xFC81{2K"iGmkz/');
      return JSON.parse(data.toString(CryptoJS.enc.Utf8));
    },
    encryptFetch:async function(data){
      console.log(data);
      app.preloader(true)
      const postData = JSON.stringify(data)
      let response = await fetch("https://api-fetch.mediadirhub.com/text-generation", {
        method:"POST",
        body:app.encrypt(postData)
      });
      app.preloader(false)
      return JSON.parse(app.decrypt(await response.text()));
    },
    textGeneration:async function(text){
      const currency = localStorage.getItem("userCurrency")?localStorage.getItem("userCurrency"):"USD";
      return app.encryptFetch({
        "method":"getText","text":text, "userId":localStorage.getItem("userId"), "appId":localStorage.getItem("aiAppId"), "currency":currency
      });
    },
    imageGeneration :async function(data){
      app.preloader(true)
      const postData = JSON.stringify(data)
      let response = await fetch("https://api-fetch.mediadirhub.com/image-generation", {
        method:"POST",
        body:app.encrypt(postData)
      });
      app.preloader(false)
      return JSON.parse(app.decrypt(await response.text()));
    },
    getPrice:async function(type, data){
      let currency = localStorage.getItem("userCurrencyCode")?localStorage.getItem("userCurrencyCode"):"";
      let userEmail = localStorage.getItem("userEmail")?localStorage.getItem("userEmail"):"";
      let country = localStorage.getItem("userCountryCode")?localStorage.getItem("userCountryCode"):"";
      if(window.location.hostname === "localhost") {
        currency = "USD";
        if(userEmail === "") {
          userEmail = "ravi@appypie.com";
        }
        country = "US";
      }
      const postData = {
        "method":type,"appId":localStorage.getItem("aiAppId"), "currency":currency, "email":userEmail, "country":country
      }
      if(data) {
        for(var key in data) {
          postData[key] = data[key];
        }
      }
      return app.encryptFetch(postData);
    },
    loadPages:async function(){
      // const response = await fetch("https://snappybeta.appypie.com/webservices/manifest-pwa.php", {
      //   method: 'POST',
      //   body: JSON.stringify({ method: "getApp", appId:localStorage.getItem("aiAppId"), prevVersion: "0" }),
      //   headers: {
      //       "Content-Type": "application/json"
      //   }
      // });
      const response = await fetch("https://api.mediadirhub.com/app/react-app-demo1.pwastore.com/1257/app");
      const data = await response.json();
      return data.home;
    },
    getTotalCredit:function(a){
      let totalCredit = 0;
      if(localStorage.getItem("textTotalCredit")) {
        totalCredit = parseInt(localStorage.getItem("textTotalCredit"));
      }
      if(a) {
        totalCredit = totalCredit + a;
        localStorage.setItem("textTotalCredit", totalCredit);
      }
      return totalCredit;
    },
    isReseller:function(){
      let isReseller = false;
      if(localStorage.getItem("isReseller")) {
        if(localStorage.getItem("isReseller") === "true") {
          isReseller = true;
        }
      }
      return isReseller;
    },
    
    is72:function(a){
      const isServer = typeof window === "undefined";
      if(!isServer) {
        const host = window.location.host;
        if(host.indexOf("pbodev.info") !== -1 || host.indexOf("72snappynormal.myapparea.com") !== -1 || host.indexOf("localhost") !== -1) {
          return true;
        }
        else {
          return false;
        }
      }
      return false;
    },
    showAlert(type, message) {
     
      // Create alert element
      let success = "bg-success";
      if(type === "danger") {
        success = "bg-danger";
      }
      const alertDiv = document.createElement('div');
      alertDiv.setAttribute("class", `toast custom-alert ${success} align-items-center text-white border-0 fade show`);
      alertDiv.setAttribute('role', 'alert');
      alertDiv.innerHTML = `
        <div class="d-flex"> <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Danger:"><use xlink:href="#exclamation-triangle-fill"></use></svg> <div class="toast-body">${message}</div>
        <button type="button" class="btn-close btn-close-white me-2 m-auto" aria-label="Close"></button></div>
      `;
      const removeAlert = () => {
        alertDiv.remove();
      };
  
      // Add event listener to the close button
      alertDiv.querySelector('.btn-close').addEventListener('click', removeAlert);
      
      // Append to body
      document.body.appendChild(alertDiv);
  
      // Automatically remove after 3 seconds
      setTimeout(() => {
        removeAlert();
      }, 3000);
    },
    videoPopup:function(properties, callback) {

      app.getCreateRoot("VideosModel").render(<VideosModel properties={properties} callback={function(key, val){
        // console.log("videoPopup---key, val", key, val)
        callback(key, val);
        if(document.querySelector(".modal .modal-close")){
          document.querySelector(".modal .modal-close").click();
        } 
      }} />);
    },

    
    getYoutube: function(src) {
      return new Promise((resolve, reject) => {
        let data = {
          embed: null,
          thumb: null,
          error: null,
          src:src,
          videoId:null
        };
    
        // Regular expression to extract video ID from YouTube URL
        var videoid = src.match(/(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([^&\n?#]+)/);
    
        if (videoid !== null) {
          videoid[1] = videoid[1].replace("embed/", "").replace("?wmode=opaque", "");
          data.embed = "https://www.youtube.com/embed/" + videoid[1] + "?rel=0&showinfo=0&enablejsapi=1";
          data.thumb = "https://img.youtube.com/vi/" + videoid[1] + "/hqdefault.jpg";
          data.videoId = videoid[1];
          resolve(data); // Resolve the Promise with data
        } else {
          data.error = "The YouTube URL is not valid.";
          reject(data); // Reject the Promise with data
        }
      });
    }
    ,

    getDailyMotion: function(src) {
      return new Promise((resolve, reject) => {
          let data = {
              embed: null,
              thumb: null,
              error: null,
              src:src,
              videoId:null
          };
          // let regex = /^.+dailymotion.com\/(video|embed)\/([^_&?/]+)/;
          let videoId = "";
          let m = src.match(/^.+dailymotion.com\/(video|hub|embed)\/([^_]+)[^#]*(#video=([^_&]+))?/);
          if (m !== null) {
              videoId = m[4] !== undefined ? m[4] : m[2];
          } 
  
          if (videoId) {
              data.embed = `https://www.dailymotion.com/embed/video/${videoId}?autoplay=0&mute=1`;
              data.thumb = `https://www.dailymotion.com/thumbnail/video/${videoId}`;
              data.videoId = videoId;
              resolve(data); 
          } else {
              data.error = "The Dailymotion URL is not valid.";
              reject(data);
          }
      });
  },
 

    getVimeo: async function (src) { 
      var id = src.substr(src.lastIndexOf("/") + 1);
      let data = {  
          embed: "https://player.vimeo.com/video/" + id,
          thumb: null,
          error: null,
          src:src,
          videoId:id
      };
      
      try {
          let response = await fetch("https://vimeo.com/api/v2/video/" + id + ".json");
          if (response.ok) {
              let videoData = await response.json();
              data.thumb = videoData[0].thumbnail_large; 
          } else {
              throw new Error("Failed to fetch video data");
          }
      } catch (error) {
          data.error = error.message;
          console.error("Error:", error);
      } 
      return data;
    },

    getScreenshot: async function (website) {
      const postData = JSON.stringify({
        method:"saveWebImage",
        website
      })
      let response = await fetch("https://api-fetch.mediadirhub.com/screenshot-generation", {
        method:"POST",
        body:app.encrypt(postData)
      });
      return JSON.parse(app.decrypt(await response.text()));
    },
    textSearch:async function(pageId, searchText, controller) {
      try {
        let response = await fetch(app.config().postURL, {
          signal: controller.signal,
          method:"POST",
          body:JSON.stringify({
            "appId": localStorage.getItem("aiAppId"), 
            "pageId": pageId, 
            "searchText": searchText,
            "method" : "storeDeepLink"
          })
        })
        response = await response.json();
        if(response.data) {
          response.data = response.data.filter(function(v){
            if(v.status === 0) {
              return false;
            }
            return true;
          })
        }
        return response;
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    iconsFilter:function(type){
      let pages = [];
      if(localStorage.getItem("featurePages")) {
        pages = JSON.parse(localStorage.getItem("featurePages"));
      }
      const data = {
        cart:["ecommerce", "dinein", "foodcourt", "foodordering", "hyperstore", "digitalstore"],
        location:["auction", "dating", "datingrevamp", "dinein", "event", "foodcourt", "hyperlocal", "loyaltycard", "loyalty","services", "taxi-ride", "demanddelivery"],
        notification:["notification"]
      }
      let mode = "";
      if(type === "cart") {
        mode = "cart-no";
        pages.forEach(function(v){
          if(data[type].indexOf(v.pageIdentifier) !== -1) {
            mode = "cart-yes";
          }
          if(data[type].indexOf(v.pageid) !== -1) {
            mode = "cart-yes";
          }
        })
      }
      if(type === "location") {
        mode = "location-no";
        pages.forEach(function(v){
          if(data[type].indexOf(v.pageIdentifier) !== -1) {
            mode = "location-yes";
          }
          if(data[type].indexOf(v.pageid) !== -1) {
            mode = "location-yes";
          }
        })
      }
      if(type === "notification") {
        mode = "notification-yes";
        // mode = "notification-no";
        // pages.forEach(function(v){
        //   if(data[type].indexOf(v.pageIdentifier) !== -1) {
        //     mode = "notification-yes";
        //   }
        //   if(data[type].indexOf(v.pageid) !== -1) {
        //     mode = "notification-yes";
        //   }
        // })
      }
      return mode;
    },  
    phoneKeyDown(event) {
      const allowedKeys = [
        'Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab', // Navigation keys
        '-', '+', // Signs
      ];
  
      // Allow control keys and navigation keys
      if ((allowedKeys.includes(event.key) || (event.key >= '0' && event.key <= '9'))) {
          return; // Allow the key
      }
      
  
      // Prevent other keys
      event.preventDefault();
    },
    isWebsiteBuilder:function(){
      const isServer = typeof window === "undefined";
      if(!isServer) {
        if(window.location.pathname === "/website/creator-software/build"){
          return true;
        }
      }
      return false; 
    },
    allowOnlyImages:function(file) {
      //const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
      const allowedTypes = ['image/jpeg', 'image/png'];
      //alert(file.type);
      if (!allowedTypes.includes(file.type)) {
        //alert(app.getLang("onlyAllowedFormats"));
        //input.value = ''; // Clear the input
        return false;
      }
      return true; // All files are valid images
    },
  defaultData:function(key) {
    const data = {};
    config[key].forEach(function(v){
        if(v.key === "domain") {
          data[v.key] = "karmtrust.org";
        }
        else {
          if(v.type === "select" || v.type === "tabs") {
            data[v.key] = v.options[0].value;
          }
          else {
            data[v.key] = "";
          }
        }
        
    });
    return data;
  },
  getDefaultHeader:function(key) {
    const data = app.defaultData("pageKeys");
    data["name"] = "Header";
    data["url"] = "header";
    data["type"] = "header";
    data["data"] = JSON.stringify([headerJson.headerAIData[0]]);
    return data;
  },
  getDefaultFooter:function(key) {
    const data = app.defaultData("pageKeys");
    data["name"] = "Footer";
    data["url"] = "footer";
    data["type"] = "footer";
    data["data"] = JSON.stringify([footerJson.footerAIData[0]]);
    return data;
  },
  getCreateRoot:function(id, className) {
    const div = document.createElement("div");
    if(!id) {
      id = "modal-wrapper";
    }
    div.setAttribute("id", id);
    if(className) {
      div.setAttribute("class", className);
    }
    document.body.appendChild(div);
    const root = ReactDOM.createRoot(div);
    return root;
  },
  getCreateRoot2:function(id, className) {
    const div = document.createElement("div");
    if(!id) {
      id = "modal-wrapper";
    }
    div.setAttribute("id", id);
    div.setAttribute("class", `modal show d-block ${className?className:""}`);
    
    div.style.background = "rgba(0,0,0,0.4)";
    document.body.appendChild(div);
    const root = ReactDOM.createRoot(div);
    return root;
  },
  htmlPreview:function(v) {
    const host = document.createElement("div");
    host.id = "html-preview";
    document.body.appendChild(host);
    const shadow = host.attachShadow({ mode: "open" });
    shadow.innerHTML = htmlPreview(v, []);
  },
  htmlToImage:async function(v) {
    const host = document.createElement("div");
    host.id = "html-preview";
    document.body.appendChild(host);
    const shadow = host.attachShadow({ mode: "open" });
    shadow.innerHTML = htmlPreview(v, []);

    const canvas = await html2canvas(shadow.querySelector(".page_body"), { backgroundColor: "#ffffff" });
    const base64 = canvas.toDataURL("image/png");
    host.remove();
    return base64;
  },
  createPopup:function(popup, id, className) {
    const div = document.createElement("div");
    if(!id) {
      id = "modal-wrapper";
    }
    div.setAttribute("id", id);
    div.setAttribute("class", `modal show d-block ${className?className:""}`);
    
    div.style.background = "rgba(0,0,0,0.4)";
    document.body.appendChild(div);
    const root = ReactDOM.createRoot(div);
    root.render(<Modal2 close={function(){
      
      document.querySelector("#" + id).remove();
    }}>{popup}</Modal2>);
    
  }
}



export default app

